import dayjs from 'dayjs';
import { AuthUser } from '../../models/user';

// A row of `GET /api/users`. It is `AuthUser` with `id` and `createdAt`
// guaranteed, which is what the API returns in the listing.
//
// `last_login_at` exists since `ac614a0` (ROADMAP.md, 1.9): the login
// writes it and the listing and `GET /users/:id` return it, null while the
// account has never logged in.
export type UserRow = AuthUser & {
  id: string;
  createdAt?: string;
  last_login_at?: string | null;
};

export type UsersPage = {
  users: UserRow[];
  totalItems: number;
};

// The three filters of XD screen 8. Empty `service` and `role` =
// all. See useUsers for how each one is applied.
export type UserFilters = {
  search: string;
  service: string;
  role: '' | 'ADMIN' | 'USER';
};

export const EMPTY_USER_FILTERS: UserFilters = {
  search: '',
  service: '',
  role: '',
};

export const ROLE_LABELS: Record<'ADMIN' | 'USER', string> = {
  ADMIN: 'Admin',
  USER: 'User',
};

export const roleLabel = (role?: string): string =>
  role === 'ADMIN' || role === 'USER' ? ROLE_LABELS[role] : role || '—';

// "Dernière connexion" as the XD writes it ("10/02/2026 - 11h52"), in the
// browser's local time; "—" while the account has never logged in.
export const formatLastLogin = (value?: string | null): string => {
  if (!value) return '—';
  const date = dayjs(value);
  return date.isValid() ? date.format('DD/MM/YYYY - HH[h]mm') : '—';
};
